/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_To_Cart_1Inputs */

const en_add_to_cart_1 = /** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to Basket`)
};

const es_add_to_cart_1 = /** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir a la Cesta`)
};

const fr_add_to_cart_1 = /** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter au panier`)
};

const de_add_to_cart_1 = /** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den Warenkorb`)
};

const id_add_to_cart_1 = /** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah ke Keranjang`)
};

/** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */
const ja_add_to_cart_1 = en_add_to_cart_1;

/** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */
const zh_add_to_cart_1 = en_add_to_cart_1;

/** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */
const ar_add_to_cart_1 = en_add_to_cart_1;

/** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */
const it_add_to_cart_1 = en_add_to_cart_1;

/** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */
const ru_add_to_cart_1 = en_add_to_cart_1;

/** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */
const pt_add_to_cart_1 = en_add_to_cart_1;

/** @type {(inputs: Add_To_Cart_1Inputs) => LocalizedString} */
const ko_add_to_cart_1 = en_add_to_cart_1;

/**
* | output |
* | --- |
* | "Add to Basket" |
*
* @param {Add_To_Cart_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_to_cart_1 = /** @type {((inputs?: Add_To_Cart_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_To_Cart_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_to_cart_1(inputs)
	if (locale === "es") return es_add_to_cart_1(inputs)
	if (locale === "fr") return fr_add_to_cart_1(inputs)
	if (locale === "de") return de_add_to_cart_1(inputs)
	if (locale === "ja") return ja_add_to_cart_1(inputs)
	if (locale === "zh") return zh_add_to_cart_1(inputs)
	if (locale === "ar") return ar_add_to_cart_1(inputs)
	if (locale === "id") return id_add_to_cart_1(inputs)
	if (locale === "it") return it_add_to_cart_1(inputs)
	if (locale === "ru") return ru_add_to_cart_1(inputs)
	if (locale === "pt") return pt_add_to_cart_1(inputs)
	return ko_add_to_cart_1(inputs)
});